import styled from 'styled-components';
import {
    Container as InnerContainer,
    IconContainer as InnerIconContainer,
    Title as InnerTitle,
} from '../description-card/styled';

export const Title = styled(InnerTitle)`
    font-weight: 300;
`;

export const Container = styled(InnerContainer)`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

export const IconContainer = styled(InnerIconContainer)`
    margin: 40px 0px 0px 0px;
    display: flex;
    align-items: flex-end;
    flex-direction: column;
`;
